import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const QuotationNew = WithErrorBoundary(
  'Cotizador',
  'Error en Cotizador',
  React.lazy(() => import('./QuotationNew')),
)
const QuotationsList = WithErrorBoundary(
  'Cotizador',
  'Error en Cotizador',
  React.lazy(() => import('./QuotationsList')),
)
const QuotationNewResult = WithErrorBoundary(
  'Cotizador',
  'Error en Cotizador',
  React.lazy(() => import('./QuotationNewResult')),
)
const QuotationViewResult = WithErrorBoundary(
  'Cotizador',
  'Error en Cotizador',
  React.lazy(() => import('./QuotationViewResult')),
)
const Antiquities = WithErrorBoundary(
  'Cotizador',
  'Error en Cotizador',
  React.lazy(() => import('./Antiquities')),
)
const Grid = WithErrorBoundary(
  'Cotizador',
  'Error en Cotizador',
  React.lazy(() => import('./Grid')),
)
const SegmentMain = WithErrorBoundary(
  'Cotizador',
  'Error en Cotizador',
  React.lazy(() => import('./SegmentMain')),
)
const CarCategorization = WithErrorBoundary(
  'Cotizador',
  'Error en Cotizador',
  React.lazy(() => import('./CarCategorization')),
)

export default {
  path: '/cotizador',
  name: 'Cotizador',
  childRoutes: [
    { path: '', name: 'Quotations list', component: QuotationsList, isIndex: true},
    { path: 'nueva', name: 'Quotation new', component: QuotationNew,  },
    { path: 'resultado', name: 'Quotation new result', component: QuotationNewResult },
    { path: 'ver/:id', name: 'Quotation view result', component: QuotationViewResult },
    { path: 'categorizacion', name: 'Car categorization', component: CarCategorization },
    { path: 'clasificación', name: 'Segment main', component: SegmentMain },
    { path: 'antiguedades', name: 'Antiquities', component: Antiquities },
    { path: 'grilla', name: 'Grid', component: Grid },
  ],
}
